import { useState, useCallback, useEffect } from 'react';
import { safeGetItem, safeSetItem } from '@/lib/safeStorage';

const KEY_INTENTION = 'daily-intention';
const KEY_DATE = 'daily-intention-date';

export const useDailyIntention = () => {
  const [intention, setIntention] = useState('');
  const [isToday, setIsToday] = useState(false);

  useEffect(() => {
    const stored = safeGetItem(KEY_INTENTION) || '';
    const storedDate = safeGetItem(KEY_DATE) || '';
    const today = new Date().toDateString();
    if (storedDate === today) {
      setIntention(stored);
      setIsToday(true);
    }
  }, []);

  const saveIntention = useCallback((text: string) => {
    const today = new Date().toDateString();
    safeSetItem(KEY_INTENTION, text);
    safeSetItem(KEY_DATE, today);
    setIntention(text);
    setIsToday(true);
  }, []);

  const clearIntention = useCallback(() => {
    safeSetItem(KEY_INTENTION, '');
    setIntention('');
    setIsToday(false);
  }, []);

  return { intention, isToday, saveIntention, clearIntention };
};
